import React from "react";
import { motion } from "framer-motion";

const experiences = [
  {
    id: 1,
    company: "Clarkson University",
    logo: "/assets/clarkson-logo.png",
    role: "Graduate Research Analyst",
    duration: "Jan 2023 - Dec 2024",
    description: [
      "<strong>Implemented data preprocessing, feature selection, and cleaning</strong> processes to improve data quality and ensure reliable analytical results.",
      "Led the development of <strong>machine learning models (Random Forest, Gradient Boosting)</strong> to analyze carbon emissions from factories, improving prediction accuracy by 25%.",
      "Performed <strong>exploratory data analysis (EDA)</strong> on large datasets, extracting meaningful patterns for decision-making.",
      "Collaborated with cross-functional teams to <strong>optimize machine learning models</strong>, reducing computational overhead by 30%.",
      "Worked on <strong>data visualization dashboards</strong> using Python & Tableau to track environmental impact factors.",
      "Presented research findings at <strong>academic conferences</strong>, showcasing the impact of data science on sustainability."
    ]
  },
  {
    id: 2,
    company: "Infosys Ltd.",
    logo: "/assets/infosys-logo.svg",
    role: "Senior Systems Engineer",
    duration: "Mar 2021 - Dec 2022",
    description: [
      "<strong>Conducted end-to-end data analysis</strong> on large datasets to identify key trends and provide actionable insights for operational performance enhancement.",
      "Implemented <strong>data-driven forecasting models</strong> using Python and SQL, improving decision-making processes for internal teams by 15%.",
      "Utilized <strong>AWS cloud tools (EC2, S3, RDS)</strong> to streamline data storage, processing, and reporting for real-time analytics.",
      "<strong>Ensured data integrity</strong> by developing and implementing data validation protocols, improving the accuracy of analytics by 20%.",
      "Developed <strong>ETL pipelines</strong> to process and transform structured/unstructured data efficiently.",
      "Designed and optimized <strong>SQL queries & stored procedures</strong> to improve database performance."
    ]
  }
];

const Experience = () => {
  return (
    <section id="experience" className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        
        {/* Animated Experience Title */}
        <motion.h2
          className="text-4xl md:text-3xl font-extrabold text-center text-gray-900 mb-10 uppercase tracking-wide"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <span className="text-purple-600">E X P E R I E N C E</span>
        </motion.h2>

        {/* Grid Layout for Equal Alignment */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {experiences.map((exp) => (
            <motion.div
              key={exp.id}
              className="bg-white p-8 md:p-6 rounded-xl shadow-lg flex flex-col items-center md:items-start text-left transition-transform duration-300 hover:scale-105 hover:shadow-2xl"
              whileHover={{ scale: 1.05 }}
            >
              {/* Company Logo Centered */}
              <div className="w-full flex justify-center md:justify-start">
                <img src={exp.logo} alt={exp.company} className="w-20 h-20 mb-4" />
              </div>

              {/* Content */}
              <div className="w-full">
                <h3 className="text-2xl font-semibold">{exp.company}</h3>
                <p className="text-gray-600 font-medium">{exp.role}</p>
                <p className="text-gray-500 italic">{exp.duration}</p>
                <ul className="mt-3 text-gray-700 list-disc pl-5">
                  {exp.description.map((point, index) => (
                    <li key={index} className="mt-2" dangerouslySetInnerHTML={{ __html: point }}></li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Experience;